import React from 'react';
import { useChatbot } from '../../context/ChatbotContext';
import { TestChatTab } from '../../components/chatbot/tabs/TestChatTab';

const ChatbotTestPage: React.FC = () => {
  const { account } = useChatbot();
  return <TestChatTab account={account} />;
};

export default ChatbotTestPage;
